import { ShoppingCartCheckoutRounded, ShoppingCartRounded } from "@mui/icons-material";
import { alpha, LinearProgress, Skeleton, Stack, Typography, Fab, Tooltip, Box, Button, Rating,Chip,Select, MenuItem } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useProgramPricing } from "../../hooks/useProgramPricing";
import { useCheckCart } from "../../hooks/useCheckCart";
import { useAddToCart } from "../../hooks/useAddToCart";
import EkhoolImage from "../ekhoolImage/ekhoolImage";
import { useSnackbar } from "notistack";
import { useRouter } from "next/router";
import { reduxHelper } from "../../config/reduxHelper";
import { useProgramCacheData } from "../../hooks/useProgramCacheData";
import Label from "../extras/Label";
import { getString } from "../../functions/getString";
import Iconify from "../Iconify";
import { icons } from "../../config/icons";
import { convertToDateString } from "../../functions/convertToDateString";
import moment from "moment";
import { HTTP_REST_URLS } from "../../config/urls";
import { CALL_BACK_URL_KEY } from "../../config/key";
import Cookies from "js-cookie";
import useDevice from "../../hooks/useDevice";

export default function ProgramsCard({ item, index, view }) {

    const programId                     = item?.pb_program_id;
    const title                         = item.pb_title ? item.pb_title : item.program_name;
    const code                          = item.pb_code ? item.pb_code :""
    const enrolled                      = item.enrolled;
    const selfEnrolled                  = item.pb_has_self_enroll;
    const selfEnrolledDate              = item.pb_self_enroll_date;
    const isFutureDate                  = item?.futureDate;
    const thumbnail                     = item.pb_image ? item.pb_image : item.program_image;
    const percentage                    = item.percentage;
    const totalLearners                 = item?.enrolled_learners;
    const shortDescription              = item?.pb_short_description;
    const description                   = item?.pb_description;
    const totalRating                   = item?.pb_rating === "" ? 0 : item?.pb_rating;
    const createdDate                   = item?.created_date;
    const totalLessons                  = item?.lessons?.length;
    const unlimitedProgram              = item.unlimited_validity;
    let subscriptionEndData             = item?.subscription_end_date;
    const userSuspended                 = item?.learner_suspended;
    const lessonCount                   = item?.lessons_count;
    const courseSubscriptionExpired     = item?.expired;
    const addonsCount                   = item?.pb_products != undefined ? item?.pb_products : null;
    const courseExpired                 = item?.validity_expired;
    const certifiedCourse               = item?.pb_has_certificate;
    const CourseDuration                = item?.pb_preview_time;
    const totalEnrolledLearners         = item?.pb_total_enrollments ?? "0";
    const courseRating                  = item?.pb_rating;
    const currentDate                   = new Date().toISOString().split("T")[0];


    const strickoutDetail = item?.pb_discount_value;
    const CoursePrice = item?.pb_price;
    const percentageValue = parseInt(strickoutDetail) - parseInt(CoursePrice);
    const percentageAmount = (percentageValue / parseInt(strickoutDetail)) * 100;
    const percentageRound = Math.round(percentageAmount);

    const [priceData, setPriceData] = useState(null);
    const [itemOnCart, setItemOnCart] = useState(true);
    const [isMonthlyPay, setIsMonthlyPay] = useState();
    const [enrolling, setEnrolling] = useState(false);
     const [selectedMonth, setSelectedMonth] = useState(1);



    const { reducer } = useSelector((state) => state);
    const { appData, cartItems, headers, user } = reducer;



    const { pb_title, pb_image, } = item || {};
    const { isFree } = priceData || {};



    const { isTablet, isMobile, isDesktop } = useDevice();

    const effectiveView = isDesktop ? view : 'grid';

    if (subscriptionEndData && appData.isEthiopia) {
        if (window.convertToUserTimeZone) {
            const formatted = convertToDateString(subscriptionEndData, "dmy", "-", ":");
            const converted = window.convertToUserTimeZone(formatted);
            subscriptionEndData = converted.split(" ")[0];
        }
    }

    const dispatch = useDispatch();
    const priceSymbol = appData?.amount_details?.symbol;

    const monthPayment = item && item.pb_month_payment ? item.pb_month_payment : null;
    const parsedMonthPayment = monthPayment && JSON.parse(monthPayment);
    const filteredData = parsedMonthPayment && parsedMonthPayment.filter((i) => i.show == "1");
    const priceToShow = filteredData && filteredData.length > 0 && filteredData[0].price;

    // const totalExamCount = item?.exam_count ?? "0";
    // const totalNumberofAssignment = item?.assignment_count ?? "0";
    // const totalNumberofMaterial = item?.material_count ?? "0";
    // const totalNumberofTopics = item?.topic_count ?? "0";

    const enrolledPath = `/course/${item?.pb_slug}/learn`;
    const notEnrolledPath = `/course/${item?.pb_slug}`;
    const pathWithLastPlayed = `/course/${item?.pb_slug}/learn/${item?.ps_last_played_material}`;
    const hasLastPlayed = item?.ps_last_played_material !== undefined && item?.ps_last_played_material != 0;
    let navigatePath = enrolled && courseSubscriptionExpired
        ? notEnrolledPath
        : enrolled && hasLastPlayed
            ? pathWithLastPlayed
            : enrolled
                ? enrolledPath
                : notEnrolledPath;

    const showPricing = appData?.enable_learner_purchase;
    const enableCoursePurchase = appData?.enable_course_self_enrollment;

    // const hasAddons = Array.isArray(addonsCount) && addonsCount.length > 0;
    const hasAddons = Array.isArray(item?.addon) && item?.addon.length > 0;



    const getPriceData = async () => {
        const result = useProgramPricing({ program_detail: item });
        setPriceData(result);
    };


    const checkItemOnCart = async () => {
        const result = await useCheckCart(`p-${item?.id ?? item?.program_id}`);
        setItemOnCart(result);
    };


    const getProgramPricingForMonth = () => {
        if (parsedMonthPayment != null) {
            parsedMonthPayment.forEach(i => i.show == "1" && setIsMonthlyPay(i));
        }
    };

    function post(path, params, method = 'post') {

        const form = document.createElement('form');
        form.method = method;
        form.action = path;

        for (const key in params) {
            if (params.hasOwnProperty(key)) {
                const hiddenField = document.createElement('input');
                hiddenField.type = 'hidden';
                hiddenField.name = key;
                hiddenField.value = JSON.stringify(params[key]);

                form.appendChild(hiddenField);
            }
        }

        document.body.appendChild(form);
        form.submit();
        Cookies.remove(CALL_BACK_URL_KEY);

    }
    const [jsonData, setJsonData] = useState({
        "items": [
            {
                "id": item?.id,
                "type": 1,
                "name": pb_title,
                "thumbnail": pb_image,
                "unitPrice": 0,
                "created_by": 1,
                "subscribers": [
                    {
                        "status": 1,
                        "us_name": user?.us_name,
                        "us_email": user?.us_email,
                        "id": user?.id,
                        "us_phone": user?.us_phone,
                        "item_price": 0,
                        "discount": 0,
                        "base_price": 0,
                        "tax": 0,
                        "total_price": 0,
                        "tax_mode": 2,
                        "tax_data": {
                            "SGST": 0,
                            "CGST": 0
                        },
                        "type": "1",
                        "addon": [],
                        "meta_data": {
                            "user_profile_fields": []
                        },
                        "created_by": 1
                    }
                ],
                "couponApplied": false,
                "couponDiscountVal": ""
            }
        ],
        "gross_amount": 0,
        "sub_total_price": 0,
        "total_tax": 0,
        "coupon_applied": false,
        "coupon_id": "",
        "coupon_discount": 0,
        "total_price": 0,
        "sold_by": "",
        "user_details": {
            "id": user?.id,
            "us_name": user?.us_name,
            "us_email": user?.us_email,
            "us_phone": user?.us_phone,
            "billing_details": {
                "billing_name": user?.us_name,
                "billing_email": user?.us_email,
                "billing_phone": user?.us_phone,
                "billing_street": "",
                "billing_state": "",
                "billing_city": "",
                "billing_district": ""
            }
        },
        "payment_success_callback": '',
        "payment_error_callback": "/cart",
        "payment_mode": 1,
        "theme": "red",
        "referral_by": "",
        "payment_due_date": "",
        "addonPrice": 0,
        "deliveryCharges": 0,
        "couponCode": null,
        "couponForallCourses": true,
        "couponDiscount": 0,
        "couponDiscountVal": ""
    })


    const enrollFreeProgram = async () => {
        if (user) {
            jsonData['payment_success_callback'] = `/course/${item?.pb_slug}/learn`;
            const data = {
                data: jsonData
            }
            post(HTTP_REST_URLS.PAYMENT_URL, data)
        }
        else {
            dispatch({
                type: reduxHelper.UPDATE_ALERT,
                payload: true
            })
        }

    }

    const checkLoginEnroll = () => {
        const result = Cookies.get(CALL_BACK_URL_KEY)
        if (result) {
            const parsedResult = JSON.parse(result)
            if (parsedResult?.type === 'checkout' && isFree) {
                if (user?.us_role_id == 2) {
                    setEnrolling(true)
                    enrollFreeProgram()
                }
            }
        }
    }

    useEffect(() => {
        checkLoginEnroll()
    }, [slug, isFree, user])



    const getProgramLastMaterial = async () => {
        const ProgramLastMaterial = await useProgramCacheData();
        const LastViewed = ProgramLastMaterial.filter((i) => i.program_id === programId);
        if (LastViewed.length > 0) {
            item.ps_last_played_material = LastViewed[0].material_id;
        }
    };

    useEffect(() => { getProgramLastMaterial() }, [item, item]);
    useEffect(() => { getProgramPricingForMonth() }, []);
    useEffect(() => { getPriceData(); checkItemOnCart() }, [item]);
    useEffect(() => { checkItemOnCart() }, []);


    const { enqueueSnackbar } = useSnackbar();


    const addToCart = async () => {
        if (itemOnCart) {
            push("/cart");
        } else {
            const result = await useAddToCart(`p-${item?.id ?? item?.program_id}`);
            enqueueSnackbar(getString("Added to cart"), { variant: "success" });
            setItemOnCart(true);
            dispatch({
                type: reduxHelper.UPDATE_CART_ITEMS,
                payload: [...cartItems, `p-${item?.id ?? item?.program_id}`],
            });
        }
    };


    const isPaid = priceData?.originalPrice > 0;
    const isMonthly = priceData?.isMonthlyPayment;
    const showAction =(isFree || isPaid || isMonthly || hasAddons) && (showPricing || enableCoursePurchase) && ((!enrolled && (selfEnrolled == '0' ||  selfEnrolled== "" || selfEnrolled == null || (selfEnrolled == '1' && !isFutureDate))) ||(enrolled && courseSubscriptionExpired));


    const actionConfig = useMemo(() => {
        if (!showAction) return null;

        if (isFree && !hasAddons && enableCoursePurchase) {
            
            return {
                label: getString("Enroll now"),
                onClick: enrollFreeProgram,
            };
        }

        if ((isPaid || isMonthly || (isFree && hasAddons)) && showPricing) {
            if (itemOnCart) {
                return {
                    label: getString("Go to cart"),
                    icon: <ShoppingCartCheckoutRounded />,
                    onClick: () => push("/cart"),
                };
            } else {
                return {
                    label: getString("Add to cart"),
                    icon: <ShoppingCartRounded />,
                    onClick: addToCart,
                };
            }
        }

        return null;
    }, [showAction, isFree, isPaid, isMonthly, itemOnCart, addToCart, push]);


    const { query, push } = useRouter();
    const { slug } = query;

    useEffect(() => {
        if (typeof translateScript === "function") translateScript();
    }, []);

    const monthlypayments = isMonthlyPay?.price / isMonthlyPay?.months|| 0;
    const monthlypaymentDivde = monthlypayments.toFixed(2);


    return (
        <>
            {priceData && view === "grid" && isDesktop && (
                <Stack sx={{ boxSizing: "border-box", cursor: "pointer" }} onClick={() => !courseExpired && push(navigatePath)}>
                    <Box sx={{ height: "200px" }}>
                        <EkhoolImage src={thumbnail} objectFit="cover" />
                    </Box>
                    <Box sx={{ px: "0px" }}>
                        <Box sx={{ height: "auto", marginY: "10px" }}>
                            <Typography sx={{ display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden",lineHeight: '1.3', fontSize: "17px", fontWeight: 500, height:"50px" }}>
                                {code ? `${code} - ${title}` : title}
                            </Typography>
                        </Box>                        
                        <Box sx={{ height: "35px" }}>
                            <Typography  variant="body2" color="text.secondary"                             
                                sx={{ display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden", fontSize: "14px",textOverflow: "ellipsis" }}
                            >
                                <div dangerouslySetInnerHTML={{ __html: shortDescription}} />
                            </Typography>
                        </Box>
                        {/* <Box  color="text.secondary" className="text-truncate-one-line" sx={{fontSize:'12px',marginTop: '15px'}}>Instructor : Jonas Schmedtmann, Angela Yu </Box> */}
                        {/* <Stack display={'flex'} alignItems={'flex-start'} flexDirection={'row'} flexWrap={'wrap'} gap={'6px'} mt={2} mb={2.5}>
                            <Tooltip title={`Course id : ${code}`}>
                                <Chip sx={{border: 'none',borderRadius: '6px',maxWidth:"150px",fontSize: '12px',height: 'auto',padding: '4px 0px',backgroundColor: 'var(--mo-primary-100)', color: 'var(--mo-primary)'}} 
                                    label={`Course id : ${code}`}
                                    variant="outlined"
                                />  
                            </Tooltip>
                                 
                            <Chip sx={{borderRadius: '6px',fontSize: '12px',height: 'auto',padding: '4px 0px'}} 
                                label={
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                                    
                                    <Rating
                                        value={totalRating}
                                        readOnly
                                        precision={0.1}
                                        max={1}
                                        sx={{
                                        color: "#c4710d",
                                        "& .MuiSvgIcon-root": { fontSize: "16px" },
                                        }}
                                    />
                                    <span>{totalRating}</span>
                                    </Box>
                                } 
                                variant="outlined"
                            />   
                              
                            <Chip sx={{borderRadius: '6px',fontSize: '12px',height: 'auto',padding: '4px 0px'}} 
                                label="26 contents" 
                                variant="outlined"
                            />   
                            <Chip sx={{borderRadius: '6px',fontSize: '12px',height: 'auto',padding: '4px 0px'}} 
                                label="854 users" 
                                variant="outlined"
                            />                                      
                            
                        </Stack>  */}

                        <Box sx={{ display: 'flex', gap: 1, py: "12px" }}>
                            {totalRating > 0 && (
                                <Typography sx={{ color: "#c4710d", fontSize: "14px" }}>
                                    {totalRating}
                                </Typography>
                            )}
                            <Rating value={totalRating} readOnly precision={0.1} sx={{ color: " #c4710d", "& .MuiSvgIcon-root": { fontSize: "16px", } }} />

                        </Box>

                        <Box mb={1} sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            {isFree && enableCoursePurchase? 
                                (
                                    <Typography sx={{ fontWeight: 600, fontSize: "14px" }}>Free</Typography>
                                ) : showPricing  && !isFree? 
                                (item?.pb_paytype === "1" ? 
                                    (
                                        <Box sx={{ display: "flex",alignItems: 'center', gap: 1 }}>
                                            <Typography sx={{ fontWeight: 600, fontSize: "18px" }}> {priceSymbol}{priceData?.originalPrice}</Typography>
                                            {priceData?.hasStrike && (
                                                <Typography  variant="body2" color="text.secondary" sx={{ textDecoration: "line-through", fontSize: "14px", fontWeight: "400" }}>{priceSymbol}{priceData?.strikeOutPrice}</Typography>
                                            )}
                                        </Box>
                                    ) : !isMonthlyPay?.months ? (
                                        <Typography sx={{ fontWeight: 600, fontSize: "14px" }}>
                                            -
                                        </Typography>
                                    ) : (
                                        <Stack direction="row" alignItems="center" gap={1}>
                                            <Typography variant="subtitle2" fontWeight="bold">
                                            {priceSymbol} {isMonthlyPay?.price}
                                            </Typography>

                                            <Typography variant="caption" color="text.secondary">
                                            {priceSymbol} {monthlypaymentDivde} / {getString("month")}
                                            </Typography>
                                        </Stack>
                                    )
                                ) : <></>
                            }
                            {actionConfig && (
                                <LoadingButton variant="contained" size="small" startIcon={actionConfig.icon}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        actionConfig.onClick();
                                    }}
                                    sx={{ whiteSpace: "nowrap", minWidth: 100, height: 35, borderRadius: "5px", textTransform: 'none' }}
                                >
                                    {actionConfig.label}
                                </LoadingButton>
                            )}
                           {(selfEnrolled == '1' && isFutureDate && ((isFree && enableCoursePurchase) || ((isPaid || isMonthly) && showPricing) || (showPricing && enableCoursePurchase) ) && (
                                <Typography color={'red'} variant={'caption'} fontWeight={500}>
                                    Available from <span style={{ marginLeft: 4 }}>{selfEnrolledDate}</span>
                                </Typography>
                            ))} 

                        </Box>
                        {/* {enrolled && !courseSubscriptionExpired && (
                            <LinearProgress
                                value={percentage || 0}
                                variant="determinate"
                                sx={{ height: 2 }}
                            />
                        )} */}
                    </Box>
                </Stack>
            )}


            {priceData && view === "list" && isDesktop && (
                <Stack direction="row" spacing={2} sx={{ width: "100%", borderBottom: 1, borderColor: "divider", py: 2, cursor: "pointer" }}
                    onClick={() => push(navigatePath)}
                >
                    <Box sx={{ maxWidth: "235px", height: 140, flexShrink: 0, overflow: "hidden" }}>
                        <EkhoolImage src={thumbnail} objectFit="cover" style={{ width: "100%", height: "100%" }} />
                    </Box>

                    <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <Box sx={{ maxWidth: "600px" }}>
                                <Box sx={{ height: "28px", marginY: "10px" }}>
                                    <Typography sx={{ display: "-webkit-box", WebkitLineClamp: 1, WebkitBoxOrient: "vertical", overflow: "hidden", fontSize: "16px", fontWeight: 500, textOverflow: "ellipsis", }}>
                                        {code ? `${code} - ${title}` : title}
                                    </Typography>
                                </Box>
                                <Box sx={{ height: "54px" }}>
                                    <Typography color="text.secondary"
                                        sx={{ display: "-webkit-box", WebkitLineClamp: 3, WebkitBoxOrient: "vertical", overflow: "hidden", fontSize: "14px", textOverflow: "ellipsis", fontWeight: 300 }}
                                    >
                                        <div dangerouslySetInnerHTML={{ __html: shortDescription}} />
                                    </Typography>

                                </Box>

                            </Box>
                            {isFree && enableCoursePurchase ? (
                                <Box textAlign="right" sx={{ py: "10px" }}>
                                    <Typography sx={{ fontWeight: 600, fontSize: "14px" }}>Free</Typography>
                                </Box>
                            ): showPricing  && !isFree ? 
                                (item?.pb_paytype == "1"? (
                                    <Box textAlign="right" sx={{ py: "10px" }}>
                                        <Typography sx={{ fontWeight: 600, fontSize: "14px" }}>{priceSymbol}{priceData?.originalPrice}</Typography>
                                        {priceData?.hasStrike && (
                                            <Typography color="text.secondary" sx={{ textDecoration: "line-through", fontSize: "12px" }}>{priceSymbol}{priceData?.strikeOutPrice}</Typography>
                                        )}
                                    </Box> 
                                ) : !isMonthlyPay || !isMonthlyPay.months ? (
                                     <Typography>
                                            -
                                    </Typography>
                                ):(
                                    <Stack >
                                        <Typography variant="subtitle2" fontWeight="bold">
                                            {priceSymbol} {isMonthlyPay?.price}
                                        </Typography>

                                        {isMonthlyPay?.months && (
                                            <Typography variant="caption" color="text.secondary">
                                                {priceSymbol} {monthlypaymentDivde} / {getString('month')}
                                            </Typography>
                                        )}
                                    </Stack>
                                )  
                                       
                            ) : <></>
                            }
                           
                        </Box>
                        <Box sx={{ display: "flex", justifyContent: "space-between", py: "10px", alignItems: "center" }}>
                            <Box sx={{ display: "flex", gap: 1 }}>
                                {totalRating > 0 && (<Typography sx={{ color: "#c4710d", fontSize: "14px" }}>{totalRating} </Typography>)}
                                <Rating value={totalRating} readOnly precision={0.1} sx={{ color: " #c4710d", "& .MuiSvgIcon-root": { fontSize: "16px", } }} />
                            </Box>
                            <Box>
                                {actionConfig && (
                                    <Button variant="contained" size="small" startIcon={actionConfig.icon}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            actionConfig.onClick();
                                        }}
                                        sx={{ whiteSpace: "nowrap", minWidth: 110, height: 35, borderRadius: "5px", textTransform:"none" }}
                                    >
                                        {actionConfig.label}
                                    </Button>
                                )}
                                { ( selfEnrolled == '1' &&   isFutureDate && ((isFree && enableCoursePurchase)|| ((isPaid || isMonthly) && showPricing) || (showPricing && enableCoursePurchase)) &&  (<Typography color={ 'red'} variant={'caption'} fontWeight={500}> Available from<span style={{ marginLeft: 4 }}>{selfEnrolledDate}</span>  </Typography>))}
                            </Box>
                        </Box>
                    </Box>
                </Stack>
            )}

            {priceData && view === "grid" && !isDesktop && !isMobile && (
                <Stack
                    sx={{ border: 1, borderColor: "divider", borderRadius: 2, p: 1, boxShadow: 1, cursor: "pointer", height: 370 }}
                    onClick={() => !courseExpired && push(navigatePath)}
                >
                    <Box sx={{ height: "173px" }}>
                        <EkhoolImage src={thumbnail} objectFit="cover" style={{ borderRadius: "6px", height: "100%", width: "100%" }} />
                    </Box>
                    <Typography
                        variant="subtitle1"
                        sx={{ display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden", height: "70px", fontSize: "16px", fontWeight: 500, textOverflow: "ellipsis", py: "15px" }}
                    >
                        {code ? `${code} - ${title}` : title}
                    </Typography>
                    <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden", height: "55px", fontSize: "14px", textOverflow: "ellipsis", fontWeight: 300, py: "5px" }}
                    >
                        <div dangerouslySetInnerHTML={{ __html: shortDescription}} />
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 1, py: "10px" }}>
                        {totalRating > 0 && (
                            <Typography sx={{ color: "#c4710d", fontSize: "14px" }}>
                                {totalRating}
                            </Typography>
                        )}
                        <Rating value={totalRating} readOnly precision={0.1} sx={{ color: " #c4710d", "& .MuiSvgIcon-root": { fontSize: "16px", } }} />

                    </Box>
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        {
                            isFree && enableCoursePurchase ? (
                                <Box sx={{ display: "flex", gap: 1 }}>
                                <Typography sx={{fontWeight:600, fontSize:"14px"}}>Free</Typography>
                                </Box>
                            ) : showPricing && !isFree ? (
                                item?.pb_paytype === "1" ? (
                                <Box sx={{ display: "flex", gap: 1 }}>
                                    <Typography sx={{ fontWeight: 600, fontSize: "14px" }}>
                                        {priceSymbol}{priceData?.originalPrice}
                                    </Typography>

                                    {priceData?.hasStrike && (
                                        <Typography
                                            color="text.secondary"
                                            sx={{ textDecoration: "line-through", fontSize: "13px" }}
                                        >
                                            {priceSymbol}{priceData?.strikeOutPrice}
                                        </Typography>
                                    )}
                                </Box>
                                ) : !isMonthlyPay?.months ? (
                                    <Typography sx={{ fontWeight: 600, fontSize: "14px" }}>
                                        -
                                    </Typography>
                                ) : (
                                    <Stack>
                                        <Typography variant="subtitle2" fontWeight="bold">
                                            {priceSymbol} {isMonthlyPay?.price}
                                        </Typography>

                                        <Typography variant="caption" color="text.secondary">
                                            {priceSymbol} {monthlypaymentDivde} / {getString("month")}
                                        </Typography>
                                    </Stack>
                                )
                            ) : <></>
                        }
                        
                        {actionConfig && (
                            <Button
                                variant="contained"
                                size="small"
                                startIcon={actionConfig.icon}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    actionConfig.onClick();
                                }}
                                sx={{ whiteSpace: "nowrap", minWidth: 110, height: 35, borderRadius: "5px", textTransform:"none"}}
                            >
                                {actionConfig.label}
                            </Button>
                        )}
                        {(selfEnrolled == '1' &&   isFutureDate && ((isFree && enableCoursePurchase)|| ((isPaid || isMonthly) && showPricing) || (showPricing && enableCoursePurchase)) &&  (<Typography color={ 'red'} variant={'caption'} fontWeight={500}> Available from<span style={{ marginLeft: 4 }}>{selfEnrolledDate}</span>  </Typography>))}

                    </Box>
                    {/* {enrolled && !courseSubscriptionExpired && (
                            <LinearProgress
                                value={percentage || 0}
                                variant="determinate"
                                sx={{ height: 2 }}
                            />
                        )} */}
                </Stack>
            )}

            {priceData &&
                view === "grid" &&
                isMobile && (
                    <Stack direction="row" spacing={1} sx={{ width: "100%", border: 1, borderColor: "divider", borderRadius: 1, p: 1, boxShadow: 1, cursor: "pointer" }}
                        onClick={() => !courseExpired && push(navigatePath)}
                    >
                        <Box sx={{ width: 84, height: 72, flexShrink: 0, overflow: "hidden", }}>
                            <EkhoolImage src={thumbnail} objectFit="cover" style={{ width: "100%", height: "100%", borderRadius: "6px" }} />
                        </Box>
                        <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                            <Typography sx={{ display: "-webkit-box", WebkitLineClamp: 3, WebkitBoxOrient: "vertical", overflow: "hidden", height: "3.2em", fontSize: "14px", fontWeight: 500, textOverflow: "ellipsis" }}>
                            {code ? `${code} - ${title}` : title}
                            </Typography>
                            <Typography
                                variant="body2"
                                color="text.secondary"
                                sx={{ display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden", height: "3.2em", fontSize: "13px", textOverflow: "ellipsis", }}
                            >
                                <div dangerouslySetInnerHTML={{ __html: shortDescription}} />
                            </Typography>

                            <Box sx={{ display: 'flex', gap: 1, my: 1 }}>
                                {totalRating > 0 && (
                                    <Typography sx={{ color: "#c4710d", fontSize: "13px" }}>
                                        {totalRating}
                                    </Typography>
                                )}
                                <Rating value={totalRating} readOnly precision={0.1} sx={{ color: " #c4710d", "& .MuiSvgIcon-root": { fontSize: "15px", } }} />

                            </Box>

                            {(selfEnrolled == '1' && isFutureDate && ((isFree && enableCoursePurchase)|| ((isPaid || isMonthly) && showPricing) || (showPricing && enableCoursePurchase)) &&  (<Typography color={ 'red'} variant={'caption'} fontWeight={500}> Available from<span style={{ marginLeft: 4 }}>{selfEnrolledDate}</span>  </Typography>))}

                            <Stack direction="row" justifyContent="space-between" sx={{ mt: 1 }}>
                                {
                                    isFree && enableCoursePurchase? (
                                        <Box sx={{ display: 'flex', gap: 1, alignItems: "center" }}>
                                            <Typography sx={{ fontWeight: 600, fontSize: "13px" }}>Free </Typography>
                                        </Box>
                                    ): showPricing && !isFree ?(
                                        <Box>
                                            {item?.pb_paytype == "1" ? (
                                                <Box sx={{ display: 'flex', gap: 1, alignItems: "center" }}>
                                                    <Typography sx={{ fontWeight: 600, fontSize: "13px" }}>{priceSymbol}{priceData?.originalPrice}</Typography>
                                                    {priceData?.hasStrike && (
                                                        <Typography color="text.secondary" sx={{ textDecoration: "line-through", fontSize: "12px" }}>{priceSymbol}{priceData?.strikeOutPrice}</Typography>
                                                    )}
                                                </Box>
                                            ) : (
                                                    <Typography sx={{ fontWeight: 600, fontSize: "13px" }}>
                                                        {/* {(!isMonthlyPay || !isMonthlyPay.months) ? "-" :`${priceSymbol}${monthlypaymentDivde} / ${isMonthlyPay?.months} Months` } */}
                                                        {(!isMonthlyPay || !isMonthlyPay.months) ? "-" : (
                                                            <>
                                                                {/* {priceSymbol}{monthlypaymentDivde} /  <span>Months</span> */}
                                                                <Stack >
                                                                    <Typography variant="subtitle3" fontWeight="bold">
                                                                        {priceSymbol} {isMonthlyPay?.price} 
                                                                    </Typography>

                                                                    {isMonthlyPay?.months  && (
                                                                        <Typography variant="caption" color="text.secondary">
                                                                        {priceSymbol} {monthlypaymentDivde} / {getString('month')}
                                                                        </Typography>
                                                                    )}
                                                                </Stack>
                                                            </>
                                                        )}
                                                    </Typography>
                                            )}
                                        </Box>
                                    ): <></>
                                }

                                

                                {actionConfig && (
                                    <Button variant="contained" startIcon={actionConfig.icon}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            actionConfig.onClick();

                                        }}
                                        sx={{ whiteSpace: "nowrap", width: 100, height: 30, borderRadius: "5px", fontSize: "12px", textTransform:"none"}}

                                    >
                                        {actionConfig.label}
                                    </Button>
                                )}
                            </Stack>
                        </Box>
                    </Stack>
                )}
        </>
    );

}

